var map = {
	"./provider-logo-agile.png": 28881,
	"./provider-logo-bigBlueButton.png": 40853,
	"./provider-logo-bluejeans.png": 7458,
	"./provider-logo-chrome.png": 60517,
	"./provider-logo-customWebhook.png": 23565,
	"./provider-logo-dialpadUberconference.png": 38646,
	"./provider-logo-edge.png": 74963,
	"./provider-logo-freeConference.png": 59791,
	"./provider-logo-freshsales.png": 27330,
	"./provider-logo-goToMeeting.png": 97751,
	"./provider-logo-google.png": 59963,
	"./provider-logo-googleDrive.png": 64074,
	"./provider-logo-googleMeet.png": 82018,
	"./provider-logo-hubspot.png": 4959,
	"./provider-logo-jitsi.png": 98717,
	"./provider-logo-lifesize.png": 71317,
	"./provider-logo-microsoft.png": 31298,
	"./provider-logo-msteams.png": 76581,
	"./provider-logo-nimble.png": 1735,
	"./provider-logo-openAi.png": 51506,
	"./provider-logo-opera.png": 55979,
	"./provider-logo-pipedrive.png": 23308,
	"./provider-logo-salesforce.png": 36039,
	"./provider-logo-slack.png": 96913,
	"./provider-logo-speechGoogle.png": 80891,
	"./provider-logo-teamleader.png": 39366,
	"./provider-logo-teams.png": 2426,
	"./provider-logo-whereby.png": 73065,
	"./provider-logo-yeastar.png": 66042,
	"./provider-logo-zendesk.png": 29727,
	"./provider-logo-zoho.png": 51652,
	"./provider-logo-zohoMeeting.png": 70328,
	"./provider-logo-zoiper5.png": 7348,
	"./provider-logo-zoom.png": 39009
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31259;